window.theme.component('tabs', el => {
    const tabSelect = el.querySelector('.js-tab-select');

    /**
     * Get a tab.
     *
     * @param {int|string} tab
     */
    function getTab(tab) {
        let tabElement, tabPanel;

        if (tab === 'active') {
            tabElement = el.querySelector('.js-tab.is-active');
            if (tabElement) tabPanel = el.querySelector(`.js-tab-panel[data-index="${tabElement.dataset.index}"]`);
        } else {
            tabElement = el.querySelector(`.js-tab[data-index="${tab}"]`);
            tabPanel = el.querySelector(`.js-tab-panel[data-index="${tab}"]`);
        }

        return [tabElement, tabPanel];
    }

    /**
     * Show a tab.
     *
     * @param {int} tab
     */
    function showTab(tab) {
        const [tabElement, tabPanel] = getTab(tab);

        // Bail if the tab doesn't exist.
        if (!tabElement) {
            return;
        }

        // Hide the active tab.
        hideTab('active');

        // Show the tab.
        tabElement.classList.add('is-active');
        if (tabPanel) {
            tabPanel.classList.add('is-active');
        }

        if (tabSelect) {
            const options = Array.from(tabSelect.options);

            options.forEach(option => {
                if (option.dataset.index === tabElement.dataset.index) {
                    option.selected = true;
                }
            });
        }
    }

    /**
     * Hide a tab.
     *
     * @param {int|string} tab
     */
    function hideTab(tab) {
        const [tabElement, tabPanel] = getTab(tab);

        // Bail if the tab doesn't exist.
        if (!tabElement) {
            return;
        }

        // Hide the tab.
        tabElement.classList.remove('is-active');
        if (tabPanel) {
            tabPanel.classList.remove('is-active');
        }

        if (tabSelect) {
            const options = Array.from(tabSelect.options);

            options.forEach(option => {
                option.selected = false;
            });
        }
    }

    // Get the interaction type.
    const {interactionType = 'click'} = el.dataset;

    // Detect interaction.
    el.querySelectorAll('.js-tab').forEach(tab => {
        tab.addEventListener('click', () => {
            showTab(tab.dataset.index);
        });

        if (interactionType !== 'click') {
            tab.addEventListener('mouseenter', () => {
                showTab(tab.dataset.index);
            });
        }
    });

    // Select tab on interaction
    if (tabSelect) {
        el.querySelector('.js-tab-select').addEventListener('change', event => {
            if (!event.target.selectedOptions.length) return;

            showTab(event.target.selectedOptions[0].dataset.index);
        });
    }
});
